export const RATE_AGREEMENT_BULK_UPSERT_FIELDS: { key: string; label: string }[] = [
  { key: 'code', label: 'Code' },
  { key: 'description', label: 'Description' },
  { key: 'startDate', label: 'Start Date' },
  { key: 'endDate', label: 'End Date' }
];
